import React from 'react';

const AndroidPayPaymentSvg = (props) => (
    <svg viewBox="0 0 48 32" {...props}>
        <path
            fill="#FFF"
            d="M3 31.5C1.6 31.5.5 30.4.5 29V3C.5 1.6 1.6.5 3 .5h42c1.4 0 2.5 1.1 2.5 2.5v26c0 1.4-1.1 2.5-2.5 2.5H3z"
        />
        <path
            fill="#78C15A"
            d="M45 1c1.1 0 2 .9 2 2v26c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h42m0-1H3C1.3 0 0 1.3 0 3v26c0 1.7 1.3 3 3 3h42c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#78C15A"
            d="M24 6.2c.9 0 1.8.2 2.6.5l1.1-1.8c.1-.1.2-.1.3-.1 0 .1.1.2 0 .3l-1.1 1.7c1.8.8 3.1 3.1 3.1 4.9H17.9c0-1.9 1.3-4.1 3.1-4.9l-1.1-1.7c-.1-.1 0-.2.1-.3.1-.1.2 0 .3.1l1.1 1.8c.8-.3 1.6-.5 2.6-.5zm-1.1 16.2v3c0 .7-.6 1.4-1.4 1.4-.7 0-1.4-.6-1.4-1.4v-3H19c-.6 0-1.1-.5-1.1-1.1v-9.1H30v9.1c0 .6-.5 1.1-1.1 1.1h-1.1v3c0 .7-.6 1.4-1.4 1.4-.7 0-1.4-.6-1.4-1.4v-3h-2.1zm-6.8-10.3c.7 0 1.4.6 1.4 1.4v5.4c0 .7-.6 1.4-1.4 1.4-.7 0-1.4-.6-1.4-1.4v-5.4c0-.8.6-1.4 1.4-1.4zm15.8 0c.7 0 1.4.6 1.4 1.4v5.4c0 .7-.6 1.4-1.4 1.4-.7 0-1.4-.6-1.4-1.4v-5.4c.1-.8.7-1.4 1.4-1.4zM21.3 8.4c.4 0 .7.3.7.7 0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7zm5.4 0c.4 0 .7.3.7.7 0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7z"
        />
    </svg>
);

AndroidPayPaymentSvg.displayName = 'AndroidPayPaymentSvg';
export default AndroidPayPaymentSvg;
